import space from '@styled-system/space'
import { em } from 'polished'
import styled from 'styled-components'

import ButtonRoundedSt from 'components/ButtonRoundedSt'
import DynamicImage from 'components/DynamicImage'
import { Col } from 'styles/components/layout'
import { TextLH } from 'styles/components/typography'

export const Wrapper = styled.div`
  background-color: ${p => p.theme.colors.grayOp06NonTransp};
  border-radius: ${em(12)};
  padding-top: ${em(20)};
  padding-bottom: ${em(20)};
  padding-left: ${em(20)};
  padding-right: ${em(20)};
  width: 100%;

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(29)};
    padding-bottom: ${em(29)};
    padding-right: ${em(40)};
    background-color: ${p => p.theme.colors.lilacDark};
    color: ${p => p.theme.colors.white};
  }

  ${p => p.theme.mq.upLg} {
    padding-left: 0;
  }
`

export const TextBlock = styled(Col)`
  ${p => p.theme.mq.upMd} {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
`

export const ColCentered = styled(Col)`
  ${space};
  margin-top: ${em(12)};

  ${p => p.theme.mq.upMd} {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-top: 0;
  }
`

export const TextLHStyled = styled(TextLH)`
  display: block;
  font-size: ${p => p.theme.typography.textSmallDescr};
  line-height: ${p => p.theme.typography.textCartLegendLh};
`

export const TextLHWithOpacity = styled(TextLHStyled)`
  margin-top: ${em(5)};

  ${p => p.theme.mq.upMd} {
    opacity: 0.5;
    line-height: ${p => p.theme.typography.textCartLegendLh};
  }
`

export const ButtonContent = styled.div`
  padding: ${em(4)} ${em(14)} ${em(8)};

  span {
    white-space: nowrap;
  }

  ${p => p.theme.mq.upMd} {
    padding: 0 ${em(25)};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  display: block;
  position: relative;
  width: ${em(58)};
  height: auto;
  margin-left: auto;

  ${p => p.theme.mq.upMd} {
    width: ${em(103)};
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(103)};
    padding-right: ${em(7)};
    margin-left: auto;
  }
`

export const ButtonRoundedStStyled = styled(ButtonRoundedSt)`
  display: block;
  width: auto;

  ${p => p.theme.mq.upMd} {
    min-width: ${em(128)} !important;
  }
`
